module.exports = __webpack_public_path__ + "static/img/wooden-frame.0eae1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/wooden-frame.png
// module id = 7d4A
// module chunks = 2